import http from '@/services/http';
import { LOGIN_URL } from './urls';

export const login = async (username, password) => {
	// console.log('login with: ', username, password)
	let data;

	try {
		// console.log(shop)
		const res = await http.post(LOGIN_URL, { username, password });
		// console.log('res from login', res)
		data = res?.data;
	} catch (error) {
		console.log(error);
		return {
			error: true,
		};
	}

	return {
		data,
	};
};
